import { Injectable } from "@angular/core";
import { ServiceModelManagerServices } from "./service-model-manager.services";
import { MongoImageServices } from "./mongoImage.services";
import { MongoVideoServices } from "./mongoVideo.services";
import { AppAlertsServices } from "./app-alerts.services";
import { MongoCursorModel } from "../models/mongoCursor.model";

@Injectable()

export class AppEditorServices {
  private radioSelection: string;
  private selection: any = new Array();
  private assets: any;
  private service: any;
  private model: MongoCursorModel = new MongoCursorModel();
  private doEdit: string;
  private doIntercept: boolean =  false;
  private isSearch: boolean;

  constructor(
    private message: AppAlertsServices,
    private models: ServiceModelManagerServices,
    private images: MongoImageServices,
    private videos: MongoVideoServices
    ) {
      this.models.serviceReady.subscribe( service => {
        if ( service ) {
          switch( service ) {
            case "images":
              this.service = this.images;
              break;
            case "videos":
              this.service = this.videos;
              break;
          }
        }
      })
      this.images.onUpdatedView.subscribe( ( updatedView: any ) => {
        const { images, isSearch } = updatedView;
        const { docs } = images;
        this.isSearch = isSearch;
        this.selection = new Array();
        this.assets = updatedView.images.docs;
        if ( this.assets ) this.radioSelection = this.assets[0]['_id']
      })

      this.videos.onUpdatedView.subscribe( ( updatedView: any ) => {
        const { videos, isSearch } = updatedView;
        const { docs } = videos;
        this.isSearch = isSearch;
        this.selection = new Array();
        this.assets = docs;
        if ( this.assets ) this.radioSelection = this.assets[0]['_id']
      })
    }

  setDoEdit(): void {
    this.doEdit = 'open';
  }

  addAllAssets ( addAll: boolean ) : void {
    this.assets.map( ( asset: any ) => {
        const { _id } = asset;
        this.selection[ _id ] = addAll;
        return;
      })
  }

  setAssets( assets: any ): void {
    this.assets = assets;
  }

  getAsset( _id: string ): any {
    return this.assets.map( ( asset : any ) => {
      return ( asset['_id'] === _id ) ? asset : null ;
    });
  }

  onSubmit( event?: any ) {
    const action = event.srcElement.id;
    const selectionLength = Object.keys( this.selection ).length;

    if ( selectionLength > 0) {
      const assetIds = Object.keys(this.selection);
      const selectedIds = assetIds.map( ( asset: any ) => this.selection[ asset ] ? asset : null ).sort();
      this.model.set({ ids: selectedIds })

      while ( !selectedIds[selectedIds.length -1] ) {
        selectedIds.pop();
      }
      action === 'delete' ? this.doIntercept = true : this.executeActionOnSubmit( action ) ;

    } else {
      this.executeActionOnSubmit( action );
    }

    return;
  }

  executeActionOnSubmit( action?: any ): void {
    const thisAction = typeof action === 'string' ? action : action.srcElement.id ;
    const idsPresent = (this.model.get('ids') && this.model.get('ids').length > 0);

    if ( idsPresent ) {
      this.model.set({ method: thisAction, isSearch: this.isSearch })
      this.service[ thisAction ]( this.model );
      this.clearEditor()
    }
    else {
      this.setMessage( `${thisAction.toUpperCase()} assets!` );
    }
  }

  modelHasKey( key: string ) {
    return Object.keys(this.model).find( element => element === key);
  }

  getModelKeys() {
    return Object.keys(this.model);
  }

  setInputValue( metaKey: string , value: string ) {
    if ( this.modelHasKey( metaKey ) ) this.model[ metaKey ] = value;
  }

  getInputValue( metaKey: string ) {
    if ( this.modelHasKey( metaKey ) ) this.model[ metaKey ];
   }

  resetValue( key: any ) : void {
    this.model.reset( key );
    this.model.set({ ids: [this.radioSelection] , isSearch: this.isSearch });

    if ( this.radioSelection ) {
      this.model.set({ method: 'reset' });
      this.service.reset( this.model );
    }
    else {
      this.setMessage( "Reset Meta")
    }
    this.clearEditor();
  }

  onCancel(): void {
    this.doEdit = null;
    this.assets = null;
    this.clearEditor();
  }

  clearEditor() {
    this.doIntercept = false;
    this.model = new MongoCursorModel();
    this.selection = new Array();
  }

  setMessage( name: string ) {
    this.message.set({
      message: 'No asset selected!',
      name: name,
      status: 404,
      statusText: 'Not Found!'})
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/services/app-editor.services.ts